import { UI_ITEM_ADDED } from "./types/types";

export default (value, key) => ({
    type: UI_ITEM_ADDED,
    payload: {
        key,
        value
    }
});